import siteNameUpdateHandler from './site-name-update-handler';
import updateIntegrations from './update-integrations';

export default {
  siteNameUpdateHandler,
  updateIntegrations,
};
